module.exports = __webpack_public_path__ + "img/alex-alvarez-63YVMrL2d6g-unsplash.7c525cdd.jpg";